import { useKnockUnreadCount } from '@app/modules/notifications/feed/useKnockUnreadCount';
import { SidenavNotificationsButtonShell } from './SidenavNotificationsButtonShell';

/**
 * Knock-connected bell: reads live unread_count from the feed store.
 * Must render under KnockFeedProvider.
 */
export function SidenavNotificationsButtonKnock() {
  const count = useKnockUnreadCount();
  return <SidenavNotificationsButtonShell count={count} />;
}
